import i18n from '@/i18n';
import store from '@/store';

export default {
  install(Vue, options) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$i18n = function(path) {
      const defaultLang = store.state.lang.default;
      let lang = store.getters['lang/getLang'];
      const pathArr = path.split('.');
      if (!pathArr.length || pathArr[0] === undefined || pathArr[0] === '') {
        return '';
      }

      // Fallback auf Default (Englisch), falls die aktive Sprache nicht existiert
      if (!i18n[lang]) lang = defaultLang;

      // Loest den Pfad innerhalb einer Sprache auf; undefined = nicht gefunden
      const resolve = (langKey) => {
        let node = i18n[langKey];
        for (const step of pathArr) {
          if (node === undefined || node === null) return undefined;
          node = node[step];
        }
        return node;
      };

      const found = resolve(lang);
      if (found !== undefined) return found;

      // Pfad in der aktiven Sprache nicht vorhanden -> auf Default (Englisch) zurueckfallen
      const foundDefault = resolve(defaultLang);
      return foundDefault !== undefined ? foundDefault : '';
    };
  },
};

// Ein Feld eines Sprachblocks als getrimmter String. '' heisst "nicht
// vorhanden" - egal ob der Block fehlt, das Feld fehlt oder nur Leerraum
// darinsteht. Genau diese Gleichsetzung ist der Kern des Rueckfalls unten.
const langField = (langSet, field) => {
  if (!langSet || typeof langSet !== 'object') return '';
  const raw = langSet[field];
  if (raw === null || raw === undefined) return '';
  return String(raw).trim();
};

/**
 * Titel und Beschreibung eines Menue-/Medien-Datensatzes in der aktiven
 * Sprache, mit Rueckfall auf die Standardsprache (Englisch).
 *
 * Der Rueckfall greift FELDWEISE und schon bei einem LEEREN Wert - nicht erst,
 * wenn der ganze Sprachblock fehlt. Vorher war es umgekehrt, und daran ist die
 * Anzeige gescheitert: die Datensaetze der Mediathek tragen ALLE 20
 * Sprachbloecke, gefuellt sind darin hoechstens de und en. Der Block der
 * aktiven Sprache existierte also, war aber leer - der Rueckfall lief nie, und
 * auf dem Schirm stand nichts, obwohl unter en ein Titel steht.
 *
 * Feldweise, weil es Datensaetze mit uebersetztem Titel und unuebersetzter
 * Beschreibung gibt (und umgekehrt).
 *
 * Ein fehlender oder unbrauchbarer langMap ergibt leere Werte statt eines
 * Fehlers: aufgerufen wird auch mit dem lang eines Datensatzes, der gar keine
 * Sprachtabelle hat.
 *
 * @param {Object} langMap - { <sprachcode>: { title, description } }
 * @returns {{title: string, description: string}}
 */
export const getLang = (langMap) => {
  const map = langMap && typeof langMap === 'object' ? langMap : {};
  const active = store.getters['lang/getLang'];
  const fallback = store.state.lang.default;
  const pick = (field) => langField(map[active], field) || langField(map[fallback], field);
  return { title: pick('title'), description: pick('description') };
};



// WEBPACK FOOTER //
// ./src/plugin/LangControl.js